import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { FolderOff, CloudUpload } from '@mui/icons-material';

export default function EmptyState({ search, onUploadClick }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 10,
        color: 'text.secondary',
      }}
    >
      <FolderOff sx={{ fontSize: 64, mb: 2, opacity: 0.4 }} />
      <Typography variant="h6" gutterBottom>
        {search ? 'Nessun risultato' : 'Nessun file'}
      </Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>
        {search
          ? `Nessun file corrisponde a "${search}"`
          : 'Carica file trascinandoli qui o con il bottone "Carica"'}
      </Typography>
      {!search && onUploadClick && (
        <Button variant="contained" startIcon={<CloudUpload />} onClick={onUploadClick}>
          Carica file
        </Button>
      )}
    </Box>
  );
}
